export default [
    {
        path: '/',
        component: () => import('@/views/main/index')
    },
    {
        path: '/artist',
        name: 'Artist',
        component: () => import('@/views/artist/index')
    },
    {
        path: '/artist/info',
        component: () => import('@/views/artist/info')
    },
    {
      path: '/material',
      name: 'Material',
      component: () => import('@/views/material/index')
    },
    {
      path: '/material/info',
      component: () => import('@/views/material/info')
    },
    {
      path: '/exhibition/list',
      name: 'ExhibitionList',
      component: () => import('@/views/exhibition/list')
    },
    {
      path: '/exhibition/image',
      name: 'ExhibitionImage',
      component: () => import('@/views/exhibition/image')
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('@/views/about/index')
    }
];



// WEBPACK FOOTER //
// ./src/router/main.js